/** Peças compartilhadas das Reuniões Clínicas: avatar, datas e chips de marcação. */
import { AlertTriangle } from "lucide-react";

export const mediaUrl = (path) => (path ? `${process.env.REACT_APP_BACKEND_URL}${path}` : null);

export const dayBR = (value) => {
  if (!value) return "—";
  const [y, m, d] = String(value).slice(0, 10).split("-");
  return d ? `${d}/${m}/${y}` : value;
};

export const dateTimeBR = (value) => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
  } catch {
    return value;
  }
};

export const PatientAvatar = ({ name, initials, photoUrl, size = 44, testId }) =>
  photoUrl ? (
    <img
      data-testid={testId}
      src={mediaUrl(photoUrl)}
      alt={`Foto de ${name}`}
      style={{ width: size, height: size }}
      className="shrink-0 rounded-full object-cover"
    />
  ) : (
    <span
      data-testid={testId}
      style={{ width: size, height: size, fontSize: Math.round(size / 2.8) }}
      className="grid shrink-0 place-items-center rounded-full bg-sage-50 font-semibold text-sage-700"
      aria-label={`Sem foto — ${name}`}
    >
      {initials || "?"}
    </span>
  );

export const FlagChips = ({ flags, testId }) =>
  flags && flags.length ? (
    <span data-testid={testId} className="flex flex-wrap gap-1.5">
      {flags.map((f) => (
        <span
          key={f.flag}
          className="inline-flex items-center rounded-full bg-info/12 px-2.5 py-0.5 text-[12px] font-semibold text-info"
        >
          {f.label}
        </span>
      ))}
    </span>
  ) : null;

export const PriorityNote = ({ item, testId }) =>
  item.priority ? (
    <p
      data-testid={testId}
      className="flex items-center gap-1.5 text-[13px] font-semibold text-danger"
    >
      <AlertTriangle size={14} aria-hidden="true" />
      {item.never_discussed ? "Nunca discutido" : item.priority_label}
    </p>
  ) : null;
